import config from 'config/index';
import API from 'libs/api';
import { createAuthInstance } from 'libs/request';

interface IRoleData {
  id?: string,
  name: string,
  description: string,
  permission: string,
  customDashboard?: string,
  tenantId: string,
  status: number,
  createdDate?: string,
  createdBy?: string,
  modifiedDate?: string,
  modifiedBy?: string
}

class RoleAPI extends API {
  constructor(props?) {
    super(props);

    this.instance = this.createInstance(`${config.api.auth}role/`, createAuthInstance);
  }

  searchRole(params = {}) {
    return this.instance.get('/', {
      params,
    });
  }

  getRole(id) {
    return this.instance.get(`/${id}`);
  }

  updateRole(id, data: Partial<IRoleData>) {
    return this.instance.put(`/${id}`, data);
  }

  createRole(data: IRoleData) {
    return this.instance.post('/', data);
  }

  deleteRole(id) {
    return this.instance.delete(`/${id}`);
  }

  initRole(payload) {
    return this.instance.post('/init', payload);
  }
}

export default RoleAPI;
